import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EditUsuarioAdminComponent } from './edit-usuario-admin/edit-usuario-admin.component';
import { UsuariosAdminComponent } from './usuarios-admin/usuarios-admin.component';

const routes: Routes = [
  {
    path: '',
    component: UsuariosAdminComponent
  },
  {
    path: 'editar/:id',
    title: 'Editar Usuário Admin',
    component: EditUsuarioAdminComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UsuarioAdminRoutingModule {}
